
import axios from "axios";
import React, { useState } from "react";
import { DebouncedTextField } from "form/Debounced";
import { Drawer } from "ui/Drawer";
import {Button, Chip, CircularProgress} from "@material-ui/core";
import styled from "styled-components";

const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledPointItem = styled.div`
  display: grid;
  grid-template-columns: 34px 1fr 170px;
  grid-gap: 10px;
  margin-bottom: 20px;

  .address {
    color: #828282;
  }
`;


export default function AddPointDrawer({points, onPointAdd}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  let cancelTokenSource = null;

  const handleSearch = (value) => {
    setSearch(value);

    if (value) {
      setLoading(true);
      if (cancelTokenSource) {
        cancelTokenSource.cancel();
      }

      cancelTokenSource = axios.CancelToken.source();

      axios.get('catalog/point', {
        params: {q: value, has_services: true},
        cancelToken: cancelTokenSource.token
      }).then(res => {
        setItems(res.data.results);
        setLoading(false);
      }).catch((error) => {
        setItems([]);
        setLoading(false);
      })
    }
    else {
      setItems([]);
    }
  }

  const addPoint = (point) => {
    onPointAdd(point);
  }

  const isAlreadyInTariff = (point) => {
    return points.filter(item => item.id === point.id).length > 0;
  }

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant={'outlined'}
      >
        Добавить новые точки в тариф
      </Button>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        width={600}
      >
        <div className={'mb-20'}>
          <DebouncedTextField
            value={search}
            onChange={(value) => handleSearch(value)}
            placeholder={'Поиск точек'}
            variant={'outlined'}
            fullWidth={true}
            autoFocus={true}
          />
        </div>

        {loading && (
          <CircularProgress />
        )}

        {(search.length > 0 && !loading && items.length === 0) &&
          <div>Ничего не найдено</div>
        }

        <div>
          {items.map((item, index) =>
            <StyledPointItem key={item.id}>
              <div className={'pt-5'}>
                <Index>{index + 1}</Index>
              </div>
              <div className={'pt-5'}>
                {item.name}
                <div>
                  <span className={'address'}>{item.address ? item.address : 'Без адреса'}</span>
                </div>
                {isAlreadyInTariff(item) && (
                  <div className={'mt-5'}><Chip label={'Уже в тирифе'} size={'small'} color={'primary'} /></div>
                )}
              </div>
              <div>
                <Button onClick={() => addPoint(item)} variant={'outlined'}>Добавить точку</Button>
              </div>
            </StyledPointItem>
          )}
        </div>
      </Drawer>
    </>
  )
}